import { useEffect, useState } from "react";

export default function ReviewWidget() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const loadWidget = () => {
      setIsLoaded(true);
      const scriptSrc = "https://reputationhub.site/reputation/assets/review-widget.js";
      if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
        const script = document.createElement("script");
        script.src = scriptSrc;
        script.type = "text/javascript";
        script.async = true;
        document.body.appendChild(script);
      }
    };

    const triggerEvents = ['mousedown', 'keydown', 'scroll', 'touchstart', 'mousemove'];
    const handleInteraction = () => {
      loadWidget();
      triggerEvents.forEach(e => window.removeEventListener(e, handleInteraction));
    };

    triggerEvents.forEach(e => window.addEventListener(e, handleInteraction, { once: true, passive: true }));
    const timeoutId = setTimeout(handleInteraction, 5000); // Fallback

    return () => {
      triggerEvents.forEach(e => window.removeEventListener(e, handleInteraction));
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <section className="py-24 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">Patient Success Stories</h2>
          <p className="text-lg text-muted-foreground">
            Don&apos;t just take our word for it. See what our patients have to say about their experience and recovery at Woods Spine & Wellness.
          </p>
        </div>
        <div className="w-full max-w-6xl mx-auto bg-background rounded-2xl shadow-xl p-4 md:p-8 border border-border min-h-[300px] flex items-center justify-center">
          {isLoaded ? (
            <iframe
              className="lc_reviews_widget"
              src="https://reputationhub.site/reputation/widgets/review_widget/7UxsnzcuJDZvyZp0wk8z?widgetId=69c69a2833c5af04d0508d7e"
              frameBorder="0"
              scrolling="no"
              style={{ minWidth: "100%", width: "100%" }}
              title="Patient Reviews"
              loading="lazy"
            ></iframe>
          ) : (
            <div className="text-muted-foreground animate-pulse">Loading reviews...</div>
          )}
        </div>
      </div>
    </section>
  );
}
